// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroSection_wrapper__oWj4X","heading":"HeroSection_heading__zfSCv","heroImage":"HeroSection_heroImage__o7tLX","quant":"HeroSection_quant__nzkZ2"};